import * as React from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

export default function CollaboratorHero() {
  return (
    <Box
      id="hero"
      sx={(theme) => ({
        width: "100%",
        backgroundRepeat: "no-repeat",
        backgroundImage:
          "radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 90%), transparent)",
        ...theme.applyStyles("dark", {
          backgroundImage:
            "radial-gradient(ellipse 70% 110% at 50% -20%, hsl(210, 100%, 16%), transparent)",
        }),
      })}
    >
      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          pt: { xs: 14, sm: 20 },
          pb: { xs: 5, sm: 5 },
        }}
      >
        <Stack
          spacing={2}
          useFlexGap
          sx={{ alignItems: "center", width: { xs: "100%", sm: "70%" } }}
        >
          <Typography
            variant="h1"
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: "center",
              fontSize: "clamp(3rem, 10vw, 3.5rem)",
            }}
          >
            Nuestros&nbsp;
            <Typography
              component="span"
              variant="h1"
              sx={(theme) => ({
                fontSize: "inherit",
                color: "primary.main",
                ...theme.applyStyles("dark", {
                  color: "primary.light",
                }),
              })}
            >
              colaboradores
            </Typography>
          </Typography>
          <Typography
            sx={{
              textAlign: "center",
              color: "text.secondary",
              width: { sm: "100%", md: "80%" },
              whiteSpace: "pre-line",
            }}
          >
            La realización de las diversas actividades como foros, eventos y
            competencias a nombre de ENMICE han sido posibles gracias al
            invaluable respaldo y colaboración de instituciones clave como la
            Agencia Federal de Aviación Civil (AFAC) y la Agencia Espacial
            Mexicana (AEM), quienes desde nuestros inicios han confiado en el
            potencial de nuestros proyectos. Asimismo, destacamos el reciente
            apoyo de la Secretaría de Economía, a través de la Coordinación de
            la Industria Aeronáutica y Espacial, cuyo respaldo ha sido esencial
            para el desarrollo y el alcance de nuestras iniciativas en esta
            nueva era espacial mexicana. {"\n"} {"\n"}Junto a todos nuestros
            colaboradores, su compromiso y visión compartida han fortalecido
            significativamente la labor de ENMICE en la promoción y el impulso
            del sector aeroespacial en México.
          </Typography>
        </Stack>
      </Container>
    </Box>
  );
}
